// Statut CLIENT simplifié — les statuts techniques restent côté Admin.
// Reçu chez Colis2Go = réception PHYSIQUE uniquement (colis présents ou statut post-réception).
const RECEIVED = ["receiving", "at_hub", "awaiting_partner", "partner_selected", "collected", "consolidated", "paid_pending"];

export const clientShipStatus = (s) => {
  const st = s.status;
  if (st === "cancelled") return { label: "Annulée", cls: "bg-red-100 text-red-600" };
  if (st === "delivered") return { label: "Livré", cls: "bg-emerald-100 text-emerald-700" };
  if (st === "available") return { label: "Disponible au retrait", cls: "bg-emerald-100 text-emerald-700" };
  if (st === "arrived") return { label: "Arrivé", cls: "bg-blue-100 text-blue-700" };
  if (["shipped", "in_transit"].includes(st)) return { label: "En route", cls: "bg-indigo-100 text-indigo-700" };
  if (s.paid) {
    const dep = s.departure_date || s.etd;
    return { label: dep ? `Départ prévu : ${new Date(dep).toLocaleDateString()}` : "Payé", cls: "bg-emerald-100 text-emerald-700" };
  }
  // Devis accepté : prix verrouillé, facture activée — paiement requis avant le départ
  if (s.quote_status === "accepted" && !s.paid) {
    return { label: "Devis accepté — paiement requis", cls: "bg-amber-100 text-amber-700" };
  }
  if (s.hub_id && s.module !== "shopship" && s.final_price == null) {
    // Parcours devis : décision requise dès que l'admin a envoyé le devis
    if (s.quote_status === "sent" && s.quote?.amount != null) {
      return { label: "Devis reçu — décision requise", cls: "bg-accent text-white" };
    }
    // Tarification « Sur devis » : prix communiqué après réception/vérification au Hub
    return { label: "En attente de devis", cls: "bg-amber-100 text-amber-700" };
  }
  if (s.prepaid_invoice && !s.paid) {
    // Flux prépayé « J'ai déjà ma marchandise » : facture initiale à payer
    return { label: st === "created" ? "Expédition créée — En attente de paiement" : "En attente de paiement", cls: "bg-amber-100 text-amber-700" };
  }
  if (s.final_price != null) {
    const compl = s.balance_due && s.balance_due !== s.final_price;
    return { label: compl ? "Complément à régler" : "Facture disponible", cls: "bg-amber-100 text-amber-700" };
  }
  const received = RECEIVED.includes(st) || (s.packages || []).length > 0;
  if (received) return { label: "Reçu chez Colis2Go", cls: "bg-secondary text-primary" };
  return { label: "Déclarée — en route vers Colis2Go", cls: "bg-secondary text-muted-foreground" };
};
